export default __webpack_public_path__ + "static/media/newRequests.d3f94d64.svg";